<template>
    <form
        class="form basic-form change-password-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <h3 class="field-title">Password</h3>
        <div class="form-field">
            <label for="password">Current password:</label>
            <input
                id="password"
                v-model="form.password.value"
                type="password"
                autocomplete="current-password"
            />
            <FormError :errors="errors.password" />
        </div>

        <div class="form-field">
            <label for="password-new">New password:</label>
            <input
                id="password-new"
                v-model="form.new_password.value"
                type="password"
                autocomplete="new-password"
            />
            <FormError :errors="errors.new_password" />
        </div>

        <div class="form-field">
            <label for="password-new-confirmation">
                Password confirmation:
            </label>
            <input
                id="password-new-confirmation"
                v-model="form.new_password_confirmation.value"
                type="password"
                autocomplete="new-password"
            />
            <FormError :errors="errors.new_password_confirmation" />
        </div>

        <div v-if="successMessage" class="form-message">
            {{ successMessage }}
        </div>

        <div class="actions">
            <Bttn id="submit-password" type="submit">Change password</Bttn>
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";

export default {
    name: "ChangePasswordForm",
    components: {
        FormError,
    },
    extends: BaseForm,
    data() {
        return {
            form: {
                password: {
                    value: null,
                },
                new_password: {
                    value: null,
                },
                new_password_confirmation: {
                    value: null,
                },
            },
        };
    },
};
</script>
